interface AlertProps {
  type: 'error' | 'success'
  message: string
}

const styles = {
  error: 'text-danger bg-danger/10 border border-danger/30',
  success: 'text-brand-700 dark:text-brand-300 bg-brand-50 border border-brand-200 dark:bg-brand-500/10 dark:border-brand-500/30',
}

export default function Alert({ type, message }: AlertProps) {
  return (
    <p className={`text-sm border rounded-lg px-3 py-2 ${styles[type]}`}>
      {message}
    </p>
  )
}
